import { render, staticRenderFns } from "./HER2.vue?vue&type=template&id=5b8ad170&scoped=true"
import script from "./HER2.vue?vue&type=script&lang=js"
export * from "./HER2.vue?vue&type=script&lang=js"
import style0 from "./HER2.vue?vue&type=style&index=0&id=5b8ad170&prod&lang=scss&scoped=true"
import style1 from "./HER2.vue?vue&type=style&index=1&id=5b8ad170&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5b8ad170",
  null
  
)

export default component.exports